import React from 'react';
import { formatDateTime } from '../../utils/dateUtils';
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { LANDING_ROUTE } from '../../utils/roleLanding';
import { displayUsername } from '../../utils/userUtils';

const ImpersonationBanner: React.FC = () => {
    const { isImpersonating, user, exitImpersonation } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation('shared');

    if (!isImpersonating) return null;

    const expiresAt = user?.expiresAt
        ? formatDateTime(user.expiresAt * 1000)
        : t('impersonation.unknownExpiry');

    const handleExit = () => {
        exitImpersonation();
        navigate(LANDING_ROUTE);
    };

    return (
        <Alert
            severity="warning"
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                borderRadius: 0,
                alignItems: 'center',
            }}
            action={
                <Button color="inherit" size="small" variant="outlined" onClick={handleExit}>
                    {t('impersonation.exit')}
                </Button>
            }
        >
            <Trans
                t={t}
                i18nKey="impersonation.message"
                values={{ name: user?.name || displayUsername(user?.username), expiresAt }}
                components={{ strong: <strong /> }}
            />
        </Alert>
    );
};

export default ImpersonationBanner;
